import classNames from 'classnames';
import { memo } from 'react';
import { Types, useCartDispatch } from '../../../../context/cart';
import { useLocalization } from '../../../../context/Localization/localization';
import { ServiceItem } from '../../../../controls/ServiceItemList/ServiceItem';
import { ServiceItemList } from '../../../../controls/ServiceItemList/ServiceItemList';
import { GMTitle } from '../../../../controls/Title';
import css from '../Header.module.scss';
import { CartItemType } from './Cart.types';
import type { CartProps } from './Cart.types';

export const Cart = memo((props: CartProps) => {
    const Localization = useLocalization();
    const cartDispatch = useCartDispatch();

    return props.visible ? (
        <>
            <div data-testid={'cart-container'} className={classNames(css.cart, props.visible ? css.cartVisible : '')}>
                {(!props.items.length && <GMTitle headerLevel={4}>{Localization.YoureCartIsEmpty}</GMTitle>) || (
                    <>
                        <GMTitle headerLevel={4}>{Localization.MyCart}</GMTitle>
                        <ServiceItemList>
                            {props.items
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((item) => (
                                    <ServiceItem
                                        key={item.name + item.price}
                                        title={item.name}
                                        price={item.price}
                                        minEstCost={item.minEstCost}
                                        onDelete={() => {
                                            if (item.type === CartItemType.Service) {
                                                cartDispatch({
                                                    type: Types.RemoveService,
                                                    payload: { id: item.serviceId! },
                                                });
                                            }
                                            else if (item.type === CartItemType.MaintenanceMenu && item.serviceId && item.scheduleOption) {
                                                cartDispatch({
                                                    type: Types.RemoveMaintMenu,
                                                    payload: {
                                                        id: item.serviceId,
                                                        scheduleOption: item.scheduleOption,
                                                    },
                                                });
                                            }
                                            else if (item.type === CartItemType.XtimeService && item.serviceId && item.xtimeType) {
                                                cartDispatch({
                                                    type: Types.RemoveXtimeService,
                                                    payload: {
                                                        id: item.serviceId,
                                                        type: item.xtimeType,
                                                    },
                                                });
                                            }
                                            else if (item.type === CartItemType.XtimeMenu && item.serviceId) {
                                                cartDispatch({
                                                    type: Types.RemoveXtimeMenu,
                                                    payload: { id: item.serviceId },
                                                });
                                            }
                                            else if (item.type === CartItemType.RNDService && item.opCode) {
                                                cartDispatch({
                                                    type: Types.RemoveRNDService,
                                                    payload: { opCode: item.opCode },
                                                });
                                            }
                                        }}
                                    />
                                ))}
                        </ServiceItemList>
                    </>
                )}
            </div>
            <div
                data-testid={'cart-overlay'}
                className={css.cartOverlay}
                onClick={props.onClose}
            />
        </>
    ) : null;
});
